import * as angular from 'angular';
import GrowthMenuView from './GrowthMenuView.html';
import { GrowthFeatures } from './GrowthFeatures';
import { JourneyFeatures } from './journey/JourneyFeatures';
// Modules
import { activeMessages } from './activeMessages';
import { messages } from './messages';
import { scheduler } from './scheduler';
import { clicktracker } from './clickTracker';
import { adsbuying } from './adsBuying';
import { journey } from './journey';
import { groups } from './groups';
// Controllers
import { GrowthController } from 'modules/application/detail/growth/GrowthController';
// Services
import { GrowthSegmentService } from './GrowthSegmentService';
import { ActiveMessageService } from './activeMessages/ActiveMessageService';
import { LogConfigurationsService } from './messages/log/LogConfigurationsService';
// Constants
import { ActiveMessagesConstants } from './activeMessages/ActiveMessagesConstants';
import { JourneyConstants } from './journey/JourneyConstants';
export const growthState = 'auth.application.detail.growth';
export const growth = angular
    .module('growth', [activeMessages, messages, scheduler, clicktracker, adsbuying, groups, journey])
    .service('GrowthSegmentService', GrowthSegmentService)
    .service('ActiveMessageService', ActiveMessageService)
    .service('LogConfigurationsService', LogConfigurationsService)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state(growthState, {
            url: '/growth',
            views: {
                'sidenav@auth.application.detail': {
                    template: GrowthMenuView,
                    controller: GrowthController,
                    controllerAs: '$ctrl',
                },
            },
            params: { area: 'growth' },
            redirectTo: ActiveMessagesConstants.ACTIVE_MESSAGE_STATE,
        });
    }])
    .run(['$rootScope', '$state', '$stateParams', function ($rootScope, $state, $stateParams) {
        $rootScope.$on('$stateChangeStart', async (event, toState) => {
            if (toState.name !== growthState)
                return;
            event.preventDefault();
            try {
                const stateName = (await GrowthFeatures.isMenuRedesignEnabled() && await JourneyFeatures.isJourneyEnabled($stateParams.shortName))
                    ? JourneyConstants.JOURNEY_CAMPAIGNS_STATE
                    : ActiveMessagesConstants.ACTIVE_MESSAGE_STATE;
                $state.go(stateName);
            }
            catch (err) {
                $state.go(ActiveMessagesConstants.ACTIVE_MESSAGE_STATE);
            }
        });
    }]).name;
